import ApiService from "services/ApiService";

export const ReferrerService = {
    getReferrerDetails(code) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/Account/Referrer/Code/${code}`).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                },
                );
            });
    },
    submitReferrerForm(code, referrerDetails) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/Account/Referrer/Code/${code}/Lead`, referrerDetails).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                },
            );
        });
    }
};
